/**
 * bookingsrv API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BookingContentDTO } from './bookingContentDTO';


export interface PartnerMyBookingSearchResultItem { 
    additionalFee?: number;
    agencyMarkupValue?: number;
    approvalInvoiceId?: number;
    baseFare?: number;
    bookingCode?: string;
    bookingDate?: string;
    bookingNumber?: string;
    bookingRefNumbers?: Array<string>;
    bookingType?: PartnerMyBookingSearchResultItem.BookingTypeEnum;
    carrierNumbers?: Array<string>;
    channelType?: PartnerMyBookingSearchResultItem.ChannelTypeEnum;
    content?: BookingContentDTO;
    cooperationClass?: PartnerMyBookingSearchResultItem.CooperationClassEnum;
    createdBy?: string;
    createdDate?: string;
    departureDate?: string;
    detail?: string;
    discountAmount?: number;
    equivFare?: number;
    fromCity?: string;
    fromLocationCode?: string;
    fromLocationName?: string;
    id?: number;
    invoiceStatus?: string;
    issuedBy?: string;
    issuedDate?: string;
    issuedStatus?: PartnerMyBookingSearchResultItem.IssuedStatusEnum;
    markupValue?: number;
    orgCode?: string;
    partnerOrderId?: string;
    paymentFee?: number;
    paymentRefNumber?: string;
    paymentStatus?: PartnerMyBookingSearchResultItem.PaymentStatusEnum;
    paymentTotalAmount?: number;
    paymentType?: PartnerMyBookingSearchResultItem.PaymentTypeEnum;
    pnrs?: Array<string>;
    returnDate?: string;
    roundType?: PartnerMyBookingSearchResultItem.RoundTypeEnum;
    saleChannel?: PartnerMyBookingSearchResultItem.SaleChannelEnum;
    serviceTax?: number;
    status?: PartnerMyBookingSearchResultItem.StatusEnum;
    supplierBookingStatus?: PartnerMyBookingSearchResultItem.SupplierBookingStatusEnum;
    supplierCodes?: Array<string>;
    supplierNames?: Array<string>;
    supplierType?: PartnerMyBookingSearchResultItem.SupplierTypeEnum;
    timeToLive?: string;
    toCity?: string;
    toLocationCode?: string;
    toLocationName?: string;
    totalFare?: number;
    totalSsrValue?: number;
    totalTax?: number;
    updatedBy?: string;
    updatedDate?: string;
}
export namespace PartnerMyBookingSearchResultItem {
    export const BookingTypeEnum = {
        Dome: 'DOME',
        Inte: 'INTE'
    } as const;
    export type BookingTypeEnum = typeof BookingTypeEnum[keyof typeof BookingTypeEnum];
    export const ChannelTypeEnum = {
        Online: 'ONLINE',
        Offline: 'OFFLINE'
    } as const;
    export type ChannelTypeEnum = typeof ChannelTypeEnum[keyof typeof ChannelTypeEnum];
    export const CooperationClassEnum = {
        Ca: 'ca',
        Sa: 'sa',
        Cn: 'cn',
        Ps: 'ps',
        Nv: 'nv',
        Bd: 'bd',
        B2b2b: 'b2b2b'
    } as const;
    export type CooperationClassEnum = typeof CooperationClassEnum[keyof typeof CooperationClassEnum];
    export const IssuedStatusEnum = {
        Pending: 'PENDING',
        TicketOnProcess: 'TICKET_ON_PROCESS',
        Succeeded: 'SUCCEEDED',
        Failed: 'FAILED',
        PartlyConfirmed: 'PARTLY_CONFIRMED',
        PartlyFailed: 'PARTLY_FAILED'
    } as const;
    export type IssuedStatusEnum = typeof IssuedStatusEnum[keyof typeof IssuedStatusEnum];
    export const PaymentStatusEnum = {
        Succeeded: 'SUCCEEDED',
        Failed: 'FAILED',
        Refunded: 'REFUNDED',
        Pending: 'PENDING'
    } as const;
    export type PaymentStatusEnum = typeof PaymentStatusEnum[keyof typeof PaymentStatusEnum];
    export const PaymentTypeEnum = {
        Cash: 'CASH',
        Balance: 'BALANCE',
        VnpayCredit: 'VNPAY_CREDIT',
        AtmDebit: 'ATM_DEBIT',
        Onepay: 'ONEPAY',
        Zalo: 'ZALO',
        Applepay: 'APPLEPAY',
        Vnpayqr: 'VNPAYQR',
        Momo: 'MOMO',
        Viettelpay: 'VIETTELPAY',
        Kredivo: 'KREDIVO',
        Airpay: 'AIRPAY',
        Payoo: 'PAYOO',
        Transfer: 'TRANSFER',
        Partner: 'PARTNER',
        Vpbank: 'VPBANK',
        Shnhn: 'SHNHN',
        Credit: 'CREDIT',
        Other: 'OTHER'
    } as const;
    export type PaymentTypeEnum = typeof PaymentTypeEnum[keyof typeof PaymentTypeEnum];
    export const RoundTypeEnum = {
        Oneway: 'ONEWAY',
        Roundtrip: 'ROUNDTRIP'
    } as const;
    export type RoundTypeEnum = typeof RoundTypeEnum[keyof typeof RoundTypeEnum];
    export const SaleChannelEnum = {
        B2B: 'B2B',
        B2C: 'B2C',
        B2B2C: 'B2B2C',
        B2CWeb: 'B2C_WEB',
        B2CWebApp: 'B2C_WEB_APP',
        B2CMobile: 'B2C_MOBILE'
    } as const;
    export type SaleChannelEnum = typeof SaleChannelEnum[keyof typeof SaleChannelEnum];
    export const StatusEnum = {
        Pending: 'PENDING',
        BookingOnProcess: 'BOOKING_ON_PROCESS',
        Booked: 'BOOKED',
        PartlyBooked: 'PARTLY_BOOKED',
        Failed: 'FAILED',
        PartlyFailed: 'PARTLY_FAILED',
        Cancelled: 'CANCELLED',
        Expired: 'EXPIRED',
        Tentative: 'TENTATIVE',
        TicketOnProcess: 'TICKET_ON_PROCESS',
        Inactive: 'INACTIVE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const SupplierBookingStatusEnum = {
        Pending: 'PENDING',
        Booked: 'BOOKED',
        Confirmed: 'CONFIRMED',
        Failed: 'FAILED',
        Cancelled: 'CANCELLED',
        Expired: 'EXPIRED',
        Tentative: 'TENTATIVE',
        BookingOnProcess: 'BOOKING_ON_PROCESS',
        TicketOnProcess: 'TICKET_ON_PROCESS',
        PartlyBooked: 'PARTLY_BOOKED',
        PartlyConfirmed: 'PARTLY_CONFIRMED',
        IssueFailed: 'ISSUE_FAILED',
        ConfirmOffline: 'CONFIRM_OFFLINE'
    } as const;
    export type SupplierBookingStatusEnum = typeof SupplierBookingStatusEnum[keyof typeof SupplierBookingStatusEnum];
    export const SupplierTypeEnum = {
        Air: 'AIR',
        Hotel: 'HOTEL',
        Combo: 'COMBO',
        Tours: 'TOURS',
        Train: 'TRAIN',
        Ship: 'SHIP',
        Other: 'OTHER'
    } as const;
    export type SupplierTypeEnum = typeof SupplierTypeEnum[keyof typeof SupplierTypeEnum];
}


